import { render, staticRenderFns } from "./Persons.vue?vue&type=template&id=47d703bd&"
import script from "./Persons.vue?vue&type=script&lang=ts&"
export * from "./Persons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports